/* PhotoHouse V4: progressively enhances V1-3 product/cart presentation.
   No Cart API calls, no inventory/pricing calculations, no writes to variant IDs.
   Price mirrors Kingdom's currently displayed price, after its own update.
*/
(function () {
  'use strict';
  function nodes(root, selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }
  function getKind(holder) {
    var grid = holder.querySelector('.ph-v2__option-grid');
    if (grid && grid.classList.contains('ph-v2__option-grid--frame')) return 'frame';
    if (grid && grid.classList.contains('ph-v2__option-grid--size')) return 'size';
    var label = holder.querySelector('label');
    var t = label ? (label.textContent || '').trim().toLowerCase() : '';
    if (/גודל|מידה|size|dimensions|print size|הדפס/.test(t)) return 'size';
    if (/מסגר|frame|framing/.test(t)) return 'frame';
    return null;
  }
  function updateFrames(article) {
    var source = article.querySelector('.ph-v4__frame-image-data');
    if (!source) return;
    var sources = {
      black: source.getAttribute('data-ph-v4-black'),
      white: source.getAttribute('data-ph-v4-white'),
      wood: source.getAttribute('data-ph-v4-wood')
    };
    nodes(article, '.ph-v2__option--frame').forEach(function (button) {
      var finish = button.querySelector('.ph-v2__finish');
      if (!finish || button.dataset.phV4FrameReady === '1') return;
      var kind = finish.classList.contains('ph-v2__finish--black') ? 'black' :
        finish.classList.contains('ph-v2__finish--white') ? 'white' :
        finish.classList.contains('ph-v2__finish--wood') ? 'wood' : null;
      var url = kind && sources[kind];
      if (!url) return; // Never invent or substitute a stock/AI frame photo.
      // Only use links inserted by Shopify's image_picker settings.
      if (!/^https?:\/\//.test(url) && url.slice(0, 2) !== '//') return;
      var image = document.createElement('img');
      image.className = 'ph-v4__finish-image';
      image.alt = '';
      image.loading = 'lazy';
      image.src = url;
      finish.style.display = 'none';
      button.insertBefore(image, finish);
      button.dataset.phV4FrameReady = '1';
    });
  }
  function initProduct(article) {
    if (!article || article.dataset.phV4Init === '1') return;
    article.dataset.phV4Init = '1';
    var root = article.querySelector('.product__variants');
    var originalPrice = article.querySelector('.product__price--original');
    var summaryPrice = article.querySelector('[data-ph-v4-summary-price]');
    function syncPrice() {
      if (!originalPrice || !summaryPrice) return;
      // The Kingdom display is the source of truth. Never derive price from a frame name.
      var price = (originalPrice.textContent || '').trim();
      if (price) summaryPrice.textContent = price;
    }
    if (originalPrice && summaryPrice) {
      new MutationObserver(syncPrice).observe(originalPrice, { childList:true, subtree:true, characterData:true });
      // Liquid initialized this recap with the selected variant price. Do not
      // overwrite it with the theme's pre-initialization minimum product price.
    }
    var note = article.querySelector('[data-ph-v4-reselect]');
    if (note && window.location.hash === '#ph-v4-selection') note.hidden = false;
    if (!root) return;
    function markSteps() {
      var index = 0;
      nodes(root, '.product__variant-holder').forEach(function (holder) {
        var kind = getKind(holder);
        if (!kind) return;
        index++;
        holder.classList.add('ph-v4__step-holder');
        holder.setAttribute('data-ph-v4-step', String(index));
        var label = holder.querySelector('label');
        if (label) label.setAttribute('data-ph-v4-step', String(index));
      });
      updateFrames(article);
    }
    markSteps();
    // V2 enhances original selectors progressively. Handle its asynchronous DOM changes.
    new MutationObserver(markSteps).observe(root, { childList:true, subtree:true });
  }
  function mount() {
    if (!document.body || !document.body.classList.contains('ph-v4')) return;
    if (document.body.classList.contains('template-product') &&
        !document.body.classList.contains('template-product-portfolio')) {
      nodes(document, '.product.page-section').forEach(initProduct);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
}());
